export const filterCondition = [
    {
        label: "Discounts available",
        fields: "has_discount",
        value: true
    }
]

export const sortOptions = [
    {
        label: "Price",
        sortFields: "variants.prices.amount",
    },
    {
        label: "Title",
        sortFields: "title",
    },
    {
        label: "Sales",
        sortFields: "sales",
    },
    {
        label: "Release time",
        sortFields: "created_at",
    }
]
